export default "__VITE_ASSET__D604C5hM__"